import { useEffect, useState } from 'react';

import { unwrapResult } from '@reduxjs/toolkit';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Pagination } from '../../components/Pagination';

import { CustomerForm } from './forms/CustomerForm';

import {
  createCustomer,
  fetchListCustomer,
  selectCustomerEntity,
} from './customerSlice';

export function Customer() {
  const dispatch = useDispatch();
  const customer = useSelector(selectCustomerEntity);
  const [alert, setAlert] = useState(null);
  const [page, setPage] = useState(1);
  const [customerId, setCustomerId] = useState('');
  const [phone, setPhone] = useState('');

  useEffect(() => {
    dispatch(fetchListCustomer({ page }));
  }, [dispatch, page]);

  return (
    <Row>
      <Col>
        <h4>Danh Sách Khách Hàng</h4>
        <Form
          inline
          onSubmit={(e) => {
            e.preventDefault();
            setPage(1);
            dispatch(fetchListCustomer({ page: 1, customerId, phone }));
          }}
        >
          <Form.Label htmlFor="searchFormCustomerId" srOnly>
            Mã khách hàng
          </Form.Label>
          <Form.Control
            className="mb-2 mr-sm-2"
            id="searchFormCustomerId"
            placeholder="Nhập mã khách hàng"
            value={customerId}
            onChange={(e) => setCustomerId(e.target.value)}
          />
          <Form.Label htmlFor="searchFormPhone" srOnly>
            SDT
          </Form.Label>
          <Form.Control
            className="mb-2 mr-sm-2"
            id="searchFormPhone"
            placeholder="Nhập sdt khách hàng"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <Button type="submit" className="mb-2">
            Tìm kiếm
          </Button>
        </Form>
        <hr />
        <Table bordered responsive size="sm">
          <thead>
            <tr>
              <th>Mã KH</th>
              <th>Tên KH</th>
              <th>Email</th>
              <th>Facebook ID</th>
              <th>Địa Chỉ</th>
              <th>Giới Tính</th>
              <th>Thao Tác</th>
            </tr>
          </thead>
          <tbody>
            {customer.ids.map((id) => (
              <tr key={id}>
                <td>{customer.entities[id].customerId}</td>
                <td>{customer.entities[id].name}</td>
                <td>{customer.entities[id].email}</td>
                <td>{customer.entities[id].facebookId}</td>
                <td style={{ maxWidth: 400 }}>
                  {customer.entities[id].address}
                </td>
                <td>{customer.entities[id].gender}</td>
                <td>
                  <Link
                    to={{
                      pathname: '/admin/customer/edit',
                      state: customer.entities[id],
                    }}
                  >
                    Chỉnh sửa
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Pagination
          currentPage={page}
          totalItem={customer.total}
          onPageChange={(page) => setPage(page)}
        />
      </Col>
      <Col md={3}>
        <h4>Tạo Khách Hàng</h4>
        <hr />
        <CustomerForm
          alert={
            alert && <Alert variant={alert.variant}>{alert.content}</Alert>
          }
          onSubmit={async (data, e) => {
            setAlert(null);

            try {
              const result = await dispatch(createCustomer(data));

              unwrapResult(result);
              setAlert({ variant: 'success', content: 'Thành công!' });
              e.target.reset();
            } catch (e) {
              setAlert({ variant: 'danger', content: e.message });
            }
          }}
        />
      </Col>
    </Row>
  );
}
